<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <g clip-path="url(#clip0_2687_995)">
      <path
        d="M14.6667 7.99992C14.6667 11.6818 11.6819 14.6666 8.00001 14.6666C4.31811 14.6666 1.33334 11.6818 1.33334 7.99992M14.6667 7.99992C14.6667 4.31802 11.6819 1.33325 8.00001 1.33325M14.6667 7.99992H13M1.33334 7.99992C1.33334 4.31802 4.31811 1.33325 8.00001 1.33325M1.33334 7.99992H3.00001M8.00001 1.33325V2.99992M12.719 3.33325L8.99995 6.99992M12.719 12.7189L12.583 12.5829C12.1218 12.1217 11.8912 11.8911 11.6221 11.7262C11.3835 11.58 11.1234 11.4723 10.8513 11.4069C10.5444 11.3333 10.2183 11.3333 9.56602 11.3333L6.43398 11.3333C5.78174 11.3333 5.45562 11.3333 5.14872 11.407C4.87663 11.4723 4.61651 11.58 4.37792 11.7262C4.10881 11.8912 3.87821 12.1218 3.41701 12.583L3.2811 12.7189M3.2811 3.33325L4.43873 4.49089M9.33334 7.99992C9.33334 8.7363 8.73639 9.33325 8.00001 9.33325C7.26363 9.33325 6.66668 8.7363 6.66668 7.99992C6.66668 7.26354 7.26363 6.66659 8.00001 6.66659C8.73639 6.66659 9.33334 7.26354 9.33334 7.99992Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2687_995">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
